export default __webpack_public_path__ + "static/media/gsn_premium_small.44f44bd6.png";